import CapTable from "./CapTable";

export default CapTable;
